// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1__aa6ddb8f42eb8a70eb1a","cls2":"Cta-cls2___f326933d6eefadc3735 Cta-cls1__aa6ddb8f42eb8a70eb1a"};